import { Type } from 'class-transformer';
import { WFEVendorAccountResultDto } from '../../shared-workflow-module/_models/wfe-vendor-account-result-dto';

export class PaymentRequestPayeeInfoResultDto {
    printOwnerName: string;

    @Type(() => WFEVendorAccountResultDto)
    vendorAccounts: Array<WFEVendorAccountResultDto>;
}
